<template>
  <div class="center">
    <!-- image -->
    <img class="center__image rotate" src="@/assets/big_logo.png" alt="GPS Trace Logo" />

    <!-- text -->
    <div class="center__text">
      <div v-if="showText" class="card-center">
        <p class="card-center__label">{{ label }}</p>
        <p class="card-center__value">{{ value }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Center',
  props: {
    // show text
    showText: {
      type: Boolean,
      required: true
    },
    // label
    label: {
      type: String,
      required: true
    },
    // value
    value: {
      type: [String, Number],
      default: ''
    }
  }
}
</script>

<style>
.center {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.center__image {
  margin: 12px;
  object-fit: contain;
  height: 97%;
}
@media (max-width: 1128px) {
  .center__image {
    height: unset;
    margin: unset;
  }
}

@media (min-width: 768px) {
  .rotate {
    animation-name: rotate;
    animation-duration: 150s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;

    transform-origin: center center;
    transform: rotate(0deg);
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
}

.center__text {
  position: absolute;
  z-index: 2;

  box-sizing: border-box;
  width: calc(100vh - 100px);
  height: calc(100vh - 100px);
  font-size: 160px;
}
@media (max-width: 1128px) {
  .center__text {
    width: unset;
    height: unset;
    font-size: 80px;
  }
}
@media (max-width: 768px) {
  .center__text {
    display: none;
  }
}

.card--center,
.card-center {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media (min-width: 1128px) {
  .card-center {
    animation-name: cardcenter;
    animation-duration: 10s;
    animation-timing-function: linear;
    animation-direction: alternate-reverse;
    animation-iteration-count: infinite;
  }
  @keyframes cardcenter {
    0% { top: 30%; }
    100% { top: 70%; }
  }
}

.card-center__label {
  margin: 0;
  margin-bottom: 10px;
  font-size: 0.5em;
  text-align: center;
  color: #FFFFFF;
  text-shadow: 5px 10px 10px #000000;
}

.card-center__value {
  margin: 0;
  text-align: center;
  color: #FFFFFF;
  text-shadow: 5px 10px 10px #000000;
}
</style>